// ! Open and Close Card Modal

export const openCardModal = () => ({
    type: 'OPEN_CARD_MODAL',
});

export const closeCardModal = () => ({
    type: 'CLOSE_CARD_MODAL',
});
